import { Client } from 'openapi-fetch'

import type { paths } from '@kidzonet/ts-api-generator/clients/dashboard'

import {
    ScheduleCreateSchema,
    ScheduleSchema,
} from './types'

declare global {
    // eslint-disable-next-line vars-on-top
    var DashboardApiClient: Client<paths>
}
const apiAnswerToInterval = (item: ScheduleSchema) => ({
    id: item.id,
    policies: item.policies,
    weekdays: item.weekdays,
    startTime: item.start_time,
    stopTime: item.stop_time,
})

export const getSchedulesList = async (id?: number | null) => {
    const { data, error } = await globalThis.DashboardApiClient.GET(
        '/v1/public/dashboard/schedules',
        {
            params: {
                query: { policy_id: id },
            },
        },
    )

    if (error) {
        throw error
    }
    const { items = [] } = data
    return items.map(item => ({
        id: item.id,
        policies: item.policies,
        weekdays: item.weekdays,
        startTime: item.start_time,
        stopTime: item.stop_time,
    }))
}

export const createSchedule = async (body: ScheduleCreateSchema) => {
    const { data, error, response } = await globalThis.DashboardApiClient.POST(
        '/v1/public/dashboard/schedules',
        {
            body: {
                ...body,
                start_time: body.start_time.padStart(5, '0'),
                stop_time: body.stop_time.padStart(5, '0'),
            },
        },
    )

    if (error) {
        if ('status' in response && response.status && [409, 422].includes(response.status)) {
            return {
                ...error,
                status: response.status,
            }
        }
        throw error
    }
    return apiAnswerToInterval(data)
}

export const getSchedule = async (id: number) => {
    const { data, error } = await globalThis.DashboardApiClient.GET(
        `/v1/public/dashboard/schedules/{schedule_id}`,
        {
            params: { path: { schedule_id: id } },
        },
    )

    if (error) {
        throw error
    }
    return apiAnswerToInterval(data)
}

export const deleteSchedule = async (id: number) => {
    await globalThis.DashboardApiClient.DELETE(
        `/v1/public/dashboard/schedules/{schedule_id}`,
        {
            params: { path: { schedule_id: id } },
        },
    )
    return true
}
